// extracted by mini-css-extract-plugin
export default {"tableContainer":"Qmdar","tableDataCell":"GDpQY","tableHead":"FHisA","tableGap":"DXNaQ","listContainer":"XGO2p"};